var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 750 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 148.141037, 46.085003)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#2d4454",
    cx: 5.293,
    cy: 340.836,
    r: 57.11
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#465d6e",
    d: "M 45.064 301.03 C 46.756 302.626 48.349 304.322 49.834 306.11 C 70.614 301.75 80.344 304.59 82.334 308.68 C 84.584 313.3 79.134 322.43 68.104 332.49 C 55.724 343.8 37.584 355.49 17.044 365.49 C -3.496 375.49 -23.956 382.49 -40.466 385.28 C -55.186 387.75 -65.736 386.41 -67.986 381.78 C -69.986 377.69 -66.206 368.28 -49.986 354.62 C -50.482 352.348 -50.836 350.047 -51.046 347.73 C -76.116 367.86 -75.866 379.34 -73.326 384.44 C -65.216 401.12 -19.326 389.92 19.674 370.92 C 58.674 351.92 95.854 322.73 87.734 306.05 C 85.244 300.95 76.384 293.67 45.064 301.03 Z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2d4454",
    cx: 420.554,
    cy: 275.762,
    r: 2.12
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2d4454",
    cx: 486.254,
    cy: 93.492,
    r: 4.75
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2d4454",
    cx: -23.153,
    cy: 165.505,
    r: 12.57
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2d4454",
    cx: 632.763,
    cy: 270.994,
    r: 4.12
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2d4454",
    cx: 263.37,
    cy: 383.4,
    r: 4.12
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2d4454",
    d: "M 56.118 85.49 C 55.508 86.17 55.788 87.41 56.738 88.27 C 57.688 89.13 58.968 89.27 59.578 88.59 C 60.188 87.91 59.908 86.66 58.948 85.8 C 57.988 84.94 56.728 84.8 56.118 85.49 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2d4454",
    d: "M 47.998 78.83 C 46.898 78.49 45.618 79.47 45.148 81.01 C 44.678 82.55 45.148 84.07 46.278 84.41 C 47.408 84.75 48.648 83.77 49.128 82.23 C 49.608 80.69 49.088 79.16 47.998 78.83 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2d4454",
    d: "M 126.878 18.36 C 126.878 18.36 100.628 25.07 84.468 38.92 L 87.038 27.35 C 87.038 27.35 18.488 66.9 37.418 94.07 C 53.458 117.07 106.628 78.74 108.628 68.07 L 96.328 67.76 C 96.328 67.76 123.628 33.59 126.878 18.36 Z M 57.628 96.79 C 54.758 96.99 52.698 93.79 51.628 93.23 C 50.558 92.67 51.526 86.72 49.366 85.8 C 47.206 84.88 47.205 84.727 46.795 81.977 C 46.385 79.227 43.657 78.604 43.657 78.604 C 43.657 78.604 43.141 72.904 44.171 71.684 C 45.201 70.464 57.949 67.824 60.009 69.744 C 62.069 71.664 64.861 76.497 64.661 78.527 C 64.461 80.557 65.888 86.81 66.088 88.34 C 66.288 89.87 60.448 96.59 57.628 96.79 Z",
    transform: "matrix(0, -1, 1, 0, 20.668, 140.322328)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2d4454",
    d: "M 95.619 3.187 C 95.619 3.187 72.799 14.677 76.459 19.807 C 80.919 26.047 95.619 3.187 95.619 3.187 Z",
    transform: "matrix(0, -1, 1, 0, 73.803716, 97.876778)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2d4454",
    d: "M 40.974 46.512 C 40.974 46.512 11.544 62.122 15.204 67.252 C 19.664 73.512 40.974 46.512 40.974 46.512 Z",
    transform: "matrix(0, -1, 1, 0, -29.421405, 85.284285)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpace);
export default __webpack_public_path__ + "static/media/space.1945bb63ed0a2459f2bc56293c21f93d.svg";
export { ForwardRef as ReactComponent };